import usePokemonDetails from "../../hooks/usePokemonDetails";
import { getPokemonSpriteUrl, getPrimaryType } from "../../utils/pokemon";
import AppImage from "../AppImage/AppImage";
import "./index.css";
import "./types-colors.css";

function CardContent({ pokemonName, pokemon }) {
  const shouldLoadPokemonDetails = !pokemon && Boolean(pokemonName);
  const { pokemon: pokemonData, loading } = usePokemonDetails(pokemonName, {
    enabled: !pokemon && Boolean(pokemonName),
  });

  const selectedPokemon = pokemon || pokemonData;

  if (shouldLoadPokemonDetails && loading) {
    return (
      <div className="card-content-loading" aria-label="pokemon-card-loading">
        <div className="card-loading-circle"></div>
        <div className="card-loading-line"></div>
        <div className="card-loading-line short"></div>
      </div>
    );
  }

  if (!selectedPokemon) {
    return null;
  }

  const primaryType = getPrimaryType(selectedPokemon.types);

  return (
    <>
      {primaryType ? (
        <div className={`${primaryType}-bg pokemon-type-bg`}>
          <AppImage
            className="pokemon-img"
            alt="pokemon"
            src={getPokemonSpriteUrl(selectedPokemon.id)}
          />
        </div>
      ) : null}

      <div className="pokemon-info">
        <p className="pokemon-id">{`${selectedPokemon.id}.`}</p>
        <p className="pokemon-name">{selectedPokemon.name}</p>
      </div>
      <div className="pokemon-types">
        {selectedPokemon.types?.map((pokemonType) => (
          <p className={`${pokemonType.type.name} pokemon-type`} key={pokemonType.type.name}>
            {pokemonType.type.name}
          </p>
        ))}
      </div>
    </>
  );
}

export default CardContent;
